window.SiteReady(($) => {

  console.log('Init Block: Events');

  $('.js-event_timer').each((index, item) => {
    let $item = $(item);
    let string = $item.data('date');
    let date = new Date(string);

    // console.log($item, string, date);

    if (date instanceof Date && !isNaN(date.valueOf())) {
      let update = () => {
        let now = new Date().getTime();
        let distance = date - now;

        if (distance < 0) {
          clearInterval(interval);

          $item.parent().addClass('is_hidden');
        } else {

          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          // let seconds = Math.floor((distance % (1000 * 60)) / (1000));

          let columnNumbers = $item.find('.event_timer_number');
          let daysColumn = $item.find('.event_timer_days');
          let hoursColumn = $item.find('.event_timer_hours');
          let minutesColumn = $item.find('.event_timer_minutes');
          // let secondsColumn = $item.find('.countdown_counter_seconds .countdown_counter_number');

          // Slicing ensures number always has 0 in front of it.
          daysColumn.html(('0' + days).slice(-2));
          hoursColumn.html(('0' + hours).slice(-2));
          minutesColumn.html(('0' + minutes).slice(-2));
          // secondsColumn.html(('0' + seconds).slice(-2));
          // columnNumbers.css('opacity', 1);
        }
      }

      let interval = setInterval(update, 1000);

      update();
    }
  });
});